// TODO(ian): Replace asBool with asBoolStrict

import * as envVar from "env-var";

import { namespace } from "@formant/core/common/config";
import { getGatewayApiUrl } from "@formant/core/common/getGatewayApiUrl";

const env = envVar.from({
    ADMIN_API: process.env.ADMIN_API,
    API_BASE_URL: process.env.API_BASE_URL,
    API_PATH: process.env.API_PATH,
    APP: process.env.APP,
    AUTO_LOGIN_EMAIL: process.env.AUTO_LOGIN_EMAIL,
    AWS_ACCOUNT_ID: process.env.AWS_ACCOUNT_ID,
    BUILD_TAG: process.env.BUILD_TAG,
    DUCALIS_APP_ID: process.env.DUCALIS_APP_ID,
    DUCALIS_BOARD_ID: process.env.DUCALIS_BOARD_ID,
    DUCALIS_SECRET: process.env.DUCALIS_SECRET,
    ENABLE_SENTRY: process.env.ENABLE_SENTRY,
    GATEWAY_API_URL: process.env.GATEWAY_API_URL,
    GIT_COMMIT: process.env.GIT_COMMIT,
    GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
    HUBSPOT_TRACKING_CODE: process.env.HUBSPOT_TRACKING_CODE,
    INGESTION_API: process.env.INGESTION_API,
    INTERCOM_APP_KEY: process.env.INTERCOM_APP_KEY,
    LOG_API_ENDPOINT: process.env.LOG_API_ENDPOINT,
    LOG_JSON: process.env.LOG_JSON,
    MAPBOX_TOKEN: process.env.MAPBOX_TOKEN,
    MIXPANEL_PROJECT: process.env.MIXPANEL_PROJECT,
    MIXPANEL_TOKEN: process.env.MIXPANEL_TOKEN,
    NAMESPACE: process.env.NAMESPACE,
    PAGERDUTY_APP_ID: process.env.PAGERDUTY_APP_ID,
    QUERY_API: process.env.QUERY_API,
    SENTRY_DSN: process.env.SENTRY_DSN,
    SIGNALING_API: process.env.SIGNALING_API,
    SIGNALING_API_V2: process.env.SIGNALING_API_V2,
    SIMULATOR_SERVICE: process.env.SIMULATOR_SERVICE,
    SLACK_CLIENT_ID: process.env.SLACK_CLIENT_ID,
    STATUSPAGE_ENDPOINT: process.env.STATUSPAGE_ENDPOINT,
    STATUS_PAGE_DEPLOYMENT_METRIC_ID:
        process.env.STATUS_PAGE_DEPLOYMENT_METRIC_ID,
    STRIPE_PUBLISHABLE_KEY: process.env.STRIPE_PUBLISHABLE_KEY,
    UPLOAD_STORE_HOST: process.env.UPLOAD_STORE_HOST,
    WEBVIZ_ENDPOINT: process.env.WEBVIZ_ENDPOINT,
    TELEOP_APP: process.env.TELEOP_APP,
    WORKFLOW_GOOGLE_DRIVE_CLIENT_ID:
        process.env.WORKFLOW_GOOGLE_DRIVE_CLIENT_ID,
});

/* teleop app */
export const teleopApp = env
    .get("TELEOP_APP")
    .default("https://teleop.formant.io")
    .asString();

/*  api things */

export const floatingApiHost = document.location.origin
    .replace(/^https:\/\/app\./, "https://api.")
    .replace(/\/$/g, "");

export const apiBaseUrl = env
    .get("API_BASE_URL")
    .default(floatingApiHost)
    .asString();

export const floatingHost = apiBaseUrl.replace(
    /^https:\/\/api\./,
    "https://app.",
);

const apiPath = env.get("API_PATH").default("v1").asString();

export const adminApi = env
    .get("ADMIN_API")
    .default(`${apiBaseUrl}/${apiPath}/admin`)
    .asString();

export const queryApi = env
    .get("QUERY_API")
    .default(`${apiBaseUrl}/${apiPath}/queries`)
    .asString();

export const ingestionApi = env
    .get("INGESTION_API")
    .default(`${apiBaseUrl}/${apiPath}/ingest`)
    .asString();

export const signalingApi = env
    .get("SIGNALING_API")
    .default(`${apiBaseUrl}/${apiPath}/signaling`)
    .asString();

export const signalingApiV2 = env
    .get("SIGNALING_API_V2")
    .default(apiBaseUrl || "")
    .asString();

export const uploadStoreHost = env
    .get("UPLOAD_STORE_HOST")
    .default(`${apiBaseUrl}/upload`)
    .asString();

/* / api things */

export const autoLoginEmail = env
    .get("AUTO_LOGIN_EMAIL")
    .default("")
    .asString();

export const slackClientId = env.get("SLACK_CLIENT_ID").asString();

export const googleClientId = env.get("GOOGLE_CLIENT_ID").asString();

export const workflowGoogleDriveClientId = env
    .get("WORKFLOW_GOOGLE_DRIVE_CLIENT_ID")
    .asString();

export const pagerdutyAppId = env.get("PAGERDUTY_APP_ID").asString();

export const awsAccountId = env.get("AWS_ACCOUNT_ID").asString();

export const buildTag = env.get("BUILD_TAG").default("").asString();

export const webvizEndpoint = env.get("WEBVIZ_ENDPOINT").default("").asString();

export const mapboxToken = env.get("MAPBOX_TOKEN").asString();

export const mixpanelToken = env.get("MIXPANEL_TOKEN").asString();

export const mixpanelProject = env.get("MIXPANEL_PROJECT").asString();

export const stripePublishableKey = env
    .get("STRIPE_PUBLISHABLE_KEY")
    .asString();

export const intercomAppKey = env.get("INTERCOM_APP_KEY").asString();

export const ipsEnabled = true;

export const cancelCommandEnabled = true;

export const newVideoEnabled = true;

export const femEnabled = ["local", "dev"].includes(namespace);

export const terminalEnabled = ["local", "dev", "stage", "prod"].includes(
    namespace,
);

export const advancedMapsEnabled = ["local", "dev"].includes(namespace);

export const recordVideoEnabled = ["local", "dev", "stage"].includes(namespace);

export const statuspageEndpoint = env
    .get("STATUSPAGE_ENDPOINT")
    .default("https://formant.statuspage.io")
    .asString();

export const statusPageDeploymentMetricId = env
    .get("STATUS_PAGE_DEPLOYMENT_METRIC_ID")
    .default("9b570417mp3y")
    .asString();

export const SimulatorService = env
    .get("SIMULATOR_SERVICE")
    .default("https://simulator-queue.formant.io")
    .asString();

export const ducalisSecret = env.get("DUCALIS_SECRET").asString();

export const ducalisBoardId = env.get("DUCALIS_BOARD_ID").asString();

export const ducalisAppId = env.get("DUCALIS_APP_ID").asString();

export const hubspotTrackingCode = env
    .get("HUBSPOT_TRACKING_CODE")
    .default("5332591")
    .asString();

export const gatewayApiUrl = env
    .get("GATEWAY_API_URL")
    .default(getGatewayApiUrl(namespace))
    .asString();
